export default "__VITE_ASSET__BZwgBrEy__"